<template>
    <div class="step-evaluation-class">
        <v-alert type="info" text dense color="primary" class="mb-4">
            <div class="details-text">
                <strong>Note:</strong> The evaluation session is <strong>15 minutes</strong> long and helps us assess your current level.
            </div>
        </v-alert>

        <evaluation-calendar
            :value="value"
            selection-only
            :whatsapp-number="whatsappNumber"
            @input="$emit('input', $event)"
            @slot-selected="$emit('slot-selected', $event)"
        />
    </div>
</template>

<script>
import EvaluationCalendar from '@/components/custom/EvaluationCalendar.vue';

export default {
    name: 'WizardStepEvaluation',
    components: {
        EvaluationCalendar
    },
    props: {
        // v-model — the selected UTC datetime string
        value: {
            type: String,
            default: ''
        },
        whatsappNumber: {
            type: String,
            default: ''
        }
    },
};
</script>

<style lang="scss" scoped>
</style>
